import { getSocket } from 'src/creators/OpenReporting.creators';
import { Message, MessageState } from 'src/types';

export const onReadMessages = (
  reportId: string,
  messages: Map<string, Message[]>,
  session: string,
) => {
  const currentMessages = messages.get(reportId)?.filter((m) => m);
  const { READ } = MessageState;
  if (
    currentMessages &&
    currentMessages.some(
      ({ isReporter, state }: { isReporter: boolean; state: MessageState }) =>
        !isReporter && state !== READ,
    )
  ) {
    getSocket(session).emit('chat-read-messages', {
      token: session,
      channel: reportId,
    });
  }
};
